import { render, staticRenderFns } from "./ClockPicker.vue?vue&type=template&id=bb1f2226"
import script from "./ClockPicker.vue?vue&type=script&lang=js"
export * from "./ClockPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports